import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import type { AlertWithListProps } from "./AlertWithList.types";

export const AlertWithList = ({ title, items }: AlertWithListProps) => {
    return (
        <Alert severity="error">
            <AlertTitle
                sx={{
                    fontWeight: "bold",
                }}
            >
                {title}
            </AlertTitle>
            <Stack
                sx={{
                    pl: 2,
                }}
                direction="column"
            >
                {items.map((item, index) => (
                    <Stack key={index} direction="column">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <CircleIcon
                                sx={{
                                    color: "error.secondary",
                                    fontSize: 6,
                                }}
                            />
                            <Typography>{item.label}</Typography>
                        </Stack>
                        {item.subItems && item.subItems.length > 0 && (
                            <Stack
                                sx={{
                                    pl: 3,
                                    mt: 0.5,
                                }}
                                direction="column"
                                spacing={0.5}
                            >
                                {item.subItems.map((subItem, subIndex) => (
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        key={subIndex}
                                        spacing={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                color: "error.secondary",
                                                fontSize: 4,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {subItem.label}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        )}
                    </Stack>
                ))}
            </Stack>
        </Alert>
    );
};

export default AlertWithList;
